import type {
    AuditEventListResponse,
    CreateSupportAccessGrant,
    SupportAccessStatus,
} from '@common/types/supportAccess';
import axiosInstance from '@/services/axiosInstance';

export async function fetchSupportAccessStatus(lawFirmId: number) {
    const response = await axiosInstance.get<SupportAccessStatus>(
        `/api/v1/support-access/${lawFirmId}`,
    );
    return response.data;
}

export async function giveSupportAccess(lawFirmId: number, payload: CreateSupportAccessGrant) {
    const response = await axiosInstance.post<SupportAccessStatus>(
        `/api/v1/support-access/${lawFirmId}/grants`,
        payload,
    );
    return response.data;
}

export async function revokeSupportAccess(lawFirmId: number, supportAccessGrantId: string) {
    const response = await axiosInstance.post<SupportAccessStatus>(
        `/api/v1/support-access/${lawFirmId}/grants/${supportAccessGrantId}/revoke`,
    );
    return response.data;
}

export async function updateLawFirmPrivacy(lawFirmId: number, isPrivate: boolean) {
    const response = await axiosInstance.put<SupportAccessStatus>(
        `/api/v1/support-access/${lawFirmId}/privacy`,
        { isPrivate },
    );
    return response.data;
}

export async function fetchAuditEvents(lawFirmId: number, page: number, pageSize: number) {
    const response = await axiosInstance.get<AuditEventListResponse>(
        `/api/v1/support-access/${lawFirmId}/audit-events`,
        { params: { page, pageSize } },
    );
    return response.data;
}
